module.exports = __webpack_public_path__ + "img/fun.244c4720.svg";